import { render, staticRenderFns } from "./Transactions.html?vue&type=template&id=151e2863&"
import script from "./Transactions.js?vue&type=script&lang=js&"
export * from "./Transactions.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports